import { EshopEditor } from "@/pages/cms/e-shop/e-shop";
import { CmsAdvancedLegacyFormShell } from "@/pages/cms/advanced/LegacyFormShell";
import { useCmsNew } from "@/lib/cms/cms-new-i18n";

/**
 * Section « E-shop » du CMS avancé (`/cms/advanced/e-shop`) : RÉUTILISE la page
 * e-shop de l'ancien CMS À L'INTÉRIEUR de la coquille avancée (`<form id="e-shop">`
 * + liste des articles). L'ancienne route `/cms/e-shop` reste en place.
 */
export default function CMSAdvancedEshop() {
  const cmsNew = useCmsNew();
  return (
    <CmsAdvancedLegacyFormShell
      title={cmsNew("cms.new.nav.eshop", "E-shop")}
      formId="e-shop"
    >
      <EshopEditor />
    </CmsAdvancedLegacyFormShell>
  );
}
